"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.server = void 0;
const server = function (serv) {
    serv.getCommandBlockData = (commandBlock) => {
        const pos = commandBlock.position;
        const key = `${pos.x},${pos.y},${pos.z}`;
        let entity = serv.overworld.blockEntityData[key];
        entity = entity?.value ?? entity;
        if (!entity)
            return;
        return Object.keys(entity).reduce((acc, key) => {
            acc[key] = entity[key].value;
            return acc;
        }, {});
    };
};
exports.server = server;
